import { render, staticRenderFns } from "./RAD.vue?vue&type=template&id=16432572&"
import script from "./RAD.vue?vue&type=script&lang=js&"
export * from "./RAD.vue?vue&type=script&lang=js&"
import style0 from "./RAD.vue?vue&type=style&index=0&id=16432572&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports